#import "./sms-edition-fragment.graphql"

fragment SmsBroadcastFragment on SmsCampaign {
    id
    name
    htmlUrlPath
    deletedTime
    edition {
        ...SmsEditionFragment
    }
    owner {
        id
        name
    }
}
